// Redact only the new invitation capabilities; preserve other telemetry contracts.
export function redactEventGuestLinks(value) {
    if (typeof value === "string") return value.replace(/(\/(?:public\/events\/[^/?\s]+\/guest-confirmations|events\/[^/?\s]+\/confirm)\/)[^/?#\s"'<>]+/g, "$1[redacted]");
    if (Array.isArray(value)) return value.map(redactEventGuestLinks);
    if (value && typeof value === "object" && [Object.prototype, null].includes(Object.getPrototypeOf(value))) return Object.fromEntries(Object.entries(value).map(([key, nested]) => [key, redactEventGuestLinks(nested)]));
    return value;
}
